import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

const useCertificateGenerator = () => {
  const generatePDF = async (
    userName: string,
    plateNumber: string,
    certificateName,
    certificateHTML
  ) => {
    const certificateElement = document.getElementById(certificateHTML)
    const canvas = await html2canvas(certificateElement, {
      backgroundColor: null,
      scale: 2,
      useCORS: true,
    })
    const imgData = canvas.toDataURL('image/png')
    // eslint-disable-next-line new-cap
    const pdf = new jsPDF('landscape', 'px', 'a4')
    pdf.addImage(imgData, 'PNG', 10, 10, 580, 420)
    pdf.save(`${userName}_${plateNumber}_${certificateName}.pdf`)
  }

  return { generatePDF }
}

export default useCertificateGenerator
